import { useCallback, useEffect, useState } from 'react';

const useAccessToken = () => {
  const [accessToken, setAccessToken] = useState(localStorage.getItem('accessToken'));

  const checkAccessToken = useCallback(() => {
    if (document.visibilityState === 'visible') {
      const token = localStorage.getItem('accessToken');
      if (token !== accessToken) {
        setAccessToken(token);
      }
    }
  }, [accessToken]);

  useEffect(() => {
    document.addEventListener('visibilitychange', checkAccessToken);

    return () => {
      document.removeEventListener('visibilitychange', checkAccessToken);
    };
  }, [checkAccessToken]);
  return accessToken;
};
export default useAccessToken;
